import * as applyCouponAPI from 'aster-foundation/core/epharmacy/Checkout/redux/actions';
import { getMyOrderJson } from 'aster-foundation/core/epharmacy/myorders/redux/actions';
import * as apiActions from 'aster-foundation/core/homecare/category/redux/actions';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setInsiderObj } from 'Epharmacy/ProductDetails/redux/reducer';
import ReferralInfoBanner from 'Epharmacy/Referrals/Shared/ReferralInfoBanner';
import PromotionalOffer from 'Epharmacy/WelcomeOfferrs/PromtionalOffers';
import WelcomeOffer from 'Epharmacy/WelcomeOfferrs/WelcomeOffer';
import PackageCarousel from 'TeleConsultation/Package/PackageCarousel/PackageCarousel';
import { IC_BTN_CONSULT_DOCTOR, IC_BTN_EPHARMACY, IC_BTN_HOMECARE, IC_NO_LOCATION_ICON } from '../../Assets/images';
import { dataLayerSendEvent } from '@common/Utility/analytics-utils';
import { errorHandling, errorHandlingEpharmacy, getConfigurationValue } from '@common/Utility/common-utils';
import {
  BUTTON_NAME,
  DYNAMIC_DASHBOARD_CAROUSEL_TYPES,
  DYNAMIC_DASHBOARD_COMPONENT_TYPES,
  FLAGSMITH_KEYS,
  HOME_CARE_ROUTE,
  KSA_FLAGSMITH_KEYS,
  LOCATION_ERROR_MESSAGE,
  MODULE,
  MODULE_TYPE,
  ONE_ASTER_CATEGORY_HOME,
  ONLINE_PHARMACY_ROUTE,
  SCREEN_NAME,
  TELECONSULT_ROUTE
} from '@common/Utility/constants';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { flagsmith } from '@common/Lib/Flagsmith';
import BannerConsultation from '../BannerConsultation/BannerConsultation';
import BannerSliderWithImage from '../BannerSliderWithImage/BannerSliderWithImage';
import ClinicNearby from '../ClinicNearby/ClinicNearby';
import CommonCategoryCarousel from '../CommonCategoryCarousel/CommonCategoryCarousel';
import CommonPackageCarousel from '../CommonPackageCarousel/CommonPackageCarousel';
import CommonProductCarousel from '../CommonProductCarousel/CommonProductCarousel';
import CommonServiceCarousel from '../CommonServiceCarousel/CommonServiceCarousel';
import CommonBlogCarousel from '../CommonBlogCarousel/CommonBlogCarousel';
import FiveInOne from '../FiveInOne/FiveInOne';
import { ButtonBase } from '../Forms';
import FourInOne from '../FourInOne/FourInOne';
import HtmlBlock from '../HtmlBlock/HtmlBlock';
import MyDoctor from '../MyDoctor/MyDoctor';
import NewDoctor from '../NewDoctor/NewDoctor';
import OffBox from '../OffBox/OffBox';
import QuickUploadPrescription from '../QuickUploadPrescription/QuickUploadPrescription';
import RecentlySaved from '../RecentlySaved/RecentlySaved';
import ShopByBrands from '../ShopByBrands/ShopByBrands';
import SixInOne from '../SixInOne/SixInOne';
import SlickSlider from '../SlickSlider/SlickSlider';
import StaticBannerWithImage from '../StaticBannerWithImage/StaticBannerWithImage';
import SwitchProfileSideBar from '../SwitchProfileSideBar/SwitchProfileSideBar';
import { DynamicDashboardStyled } from './DynamicDashboardStyled';
import { ModuleButtonStyled } from './ModuleButtonStyled';
import PersonalizationCard from './PersonalizationCard/Personalization';
import QuickLinks from './QuickLinks/QuickLinks';
import { MY_ASTER_CATEGORY, PAGE_NAME } from '@common/Constants/analytics';
import InsiderRecCarousel from '../InsiderRecommenderCarousel/InsiderRecCarousel';
import EightInOne from '../EightInOne/EightInOne';
import InfoCard from '../InfoCard/InfoCard';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const ToastControl = dynamic(() => import('../ToastControl/ToastControl'), {
  ssr: false,
});

const DynamicDashboard = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation();
  const { cmsResult, type, screenType, referrerPage, triggerMyDoctorList, category, analyticsProps, screenName, page_type } = props?.dynamicValue;

  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const userLocation = useSelector((state) => state?.app?.userLocationReducer?.location);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const loggedInUserID = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource?.id);
  const familyMembers = useSelector((state) => state?.astercore?.familyMember?.data?.body);
  const insiderReducer = useSelector((state) => state?.app?.pdpReducer?.insider);
  const cartData = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);

  const [isReload, setIsReload] = React.useState(true);
  const [hasPrevOrders, setHasPrevOrders] = React.useState(null);
  const [welcomeOfferData, setWelcomeOfferData] = React.useState([]);
  const [promotionsOfferData, setPromotionsOfferData] = React.useState([]);
  const [isGuest, setIsGuest] = React.useState(true);
  const dispatch = useDispatch();

  const [checkIsProduct, setCheckIsProduct] = React.useState(true);
  const [showExistingProfileView, setShowExistingProfileView] = React.useState(false);
  const isHomecareEnabled = flagsmith.getValue('hc_web_enabled', { json: true })?.homecareEnabled;
  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});
  const enabledModules = web_feature_flaging?.enabledModules;
  const moreMenu = web_feature_flaging?.moreMenu;

  useEffect(() => {
    if (userLogin) {
      setIsGuest(false);
    }
  }, [userLogin]);

  React.useEffect(() => {
    if (userLocation?.lat && userLocation?.lng && router?.pathname === '/home-care') {
      const params = {
        latitude: userLocation?.lat,
        longitude: userLocation?.lng,
      };
      dispatch(
        apiActions?.getCheckServiceAvailability({
          params,
          onSuccess: (response) => {
            setCheckIsProduct(response?.response?.data?.isProduct);
          },
          onFailure: (err) => {
            setCheckIsProduct(true);
          },
        }),
      );
    }
  }, [userLocation?.lat, userLocation?.lng, router?.pathname]);

  const dynamicPlatform = ['Both', 'Web'];
  const filteredPlatformData = cmsResult?.filter(item => !item?.platform || item?.platform === '' || dynamicPlatform?.includes(item?.platform));

  // const renderWelcomeOffer = cmsResult?.find((content) => content?.component_type === 'Welcome Offer'); // current api doesnt support so for future ref commented.
  const renderWelcomeOffer = false;
  const renderPromotionalOffer = cmsResult?.find((content) => content?.component_type === 'Promotional Offer');
  const email = userLogin?.telecom?.find((item) => item.system === 'email')?.value;

  const isWelcomeOfferParams = {
    welcomeOffer: true,
    page: 'home',
    email: email,
    mobile: userLogin?.telecom[0]?.value || userLocation?.locationItem?.mobileNumber,
  };

  const isPromotionsOfferParams = {
    moduleName: MODULE_TYPE?.PHARMACY,
    userEmail: email,
    promoBannerType: ['bank_offers', 'others'],
    userId: userLogin?.id,
    userMobile: userLogin?.telecom[0]?.value || userLocation?.locationItem?.mobileNumber,
  };

  const responsive = [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        variableWidth: true,
        slidesToShow: 1,
        infinite: true,
      },
    },
  ];

  useEffect(() => {
    if (userLogin || guestLogin) {
      setIsReload(!isReload);
    }
  }, [userLogin, guestLogin]);

  const productIds = useMemo(() => {
    let productId = '';
    if (cartData?.delivery_groups) {
      cartData.delivery_groups.map((item, index) => {
        if (item?.sku) {
          productId += item.sku;
          if (index !== cartData.delivery_groups.length - 1) {
            productId += ',';
          }
        }
      });
    }
    return productId;
  }, [cartData?.data?.items]);

  const checkInsider = () => {
    if (window.Insider) {
      window.Insider.eventManager.once('ins-sr:only-api-campaign:load', (event, data) => {
        const updatedInsiderObj = {};
        updatedInsiderObj[data?.campaignId] = data;
        window.insiderData = { ...window.insiderData, ...updatedInsiderObj }
        dispatch(setInsiderObj({
          insider: updatedInsiderObj
        }));
      });
    } else {
      setTimeout(checkInsider, 500);
    }
  };

  useEffect(() => {
    window.insiderData = {};
    checkInsider();
  }, [router?.pathname]);

  useEffect(() => {
    if (userLogin) {
      isWelcomeOfferParams.customerId = loggedInUserID;
      isPromotionsOfferParams.customerId = loggedInUserID;
      const params = enableXUserVcpId ? { userId: userLogin?.id } : {};
      dispatch(
        getMyOrderJson({
          params,
          onSuccess: (response) => {
            setHasPrevOrders(response?.body?.orders);
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, props?.dynamicValue?.screenName || SCREEN_NAME?.ASCO, props?.dynamicValue?.page_type || PAGE_NAME.ASCO);
          },
        }),
      );
    }
    if (userLogin || guestLogin) {
      if (renderWelcomeOffer) {
        dispatch(
          applyCouponAPI.listOfCouponCode({
            params: isWelcomeOfferParams,
            onSuccess: (response) => {
              setWelcomeOfferData(response?.body?.rules);
            },
            onFailure: (err) => {
              errorHandling(err, true, props?.dynamicValue?.screenName || SCREEN_NAME?.ASCO, props?.dynamicValue?.page_type || PAGE_NAME.ASCO);
            },
          }),
        );
      }
    }

    if (renderPromotionalOffer) {
      dispatch(
        applyCouponAPI.listOfCouponCode({
          params: isPromotionsOfferParams,
          onSuccess: (response) => {
            setPromotionsOfferData(response?.body?.promoBanners);
          },
          onFailure: (err) => {
            errorHandling(err, true, props?.dynamicValue?.screenName || SCREEN_NAME?.ASCO, props?.dynamicValue?.page_type || PAGE_NAME.ASCO);
          },
        }),
      );
    }
  }, [userLogin, guestLogin]);

  useEffect(() => {
    if (!checkIsProduct) {
      setTimeout(() => {
        setCheckIsProduct(true);
      }, 3000);
    }
  }, [checkIsProduct]);

  const dashboardNavigationHandler = (buttonName, NavigationUrl, eventName, location, myAsterCategory) => {
    dataLayerSendEvent(eventName, {
      screen_name: SCREEN_NAME?.ASCO,
      page_type: PAGE_NAME?.ASCO,
      button_location: `${location}`,
      button_name: `${buttonName}`,
      myaster_category: `${myAsterCategory}`,
    });
    sendEventToSmartLook(eventName, {
      screen_name: SCREEN_NAME?.ASCO,
      page_type: PAGE_NAME?.ASCO,
      button_location: `${location}`,
      button_name: `${buttonName}`,
      myaster_category: `${myAsterCategory}`,
    });
    router.push({ pathname: generateURL(NavigationUrl) });
  };
  const showToastControl = (message) => (
    <ToastControl
      className={`${scrollY > 38 ? 'fixed' : ''}`}
      imgBox
      imgError={IC_NO_LOCATION_ICON}
      variant="yellow-dark-box floating-wrapper toast-image"
      text={message}
    />
  );

  const renderProfilesList = () => (
    <SwitchProfileSideBar
      setShowProfilesList={() => setShowExistingProfileView(false)}
      isEmptyProfile
      showOnlyExistingProfile
      setIsMemberAdded={props?.setIsMemberAdded}
      referrerPage={referrerPage}
    />
  );

  return (
    <DynamicDashboardStyled>
      {!checkIsProduct && showToastControl(LOCATION_ERROR_MESSAGE)}
      {showExistingProfileView && renderProfilesList()}
      {type === ONE_ASTER_CATEGORY_HOME.CORE && familyMembers?.length > 0 && (
        <PersonalizationCard
          setShowExistingProfileView={setShowExistingProfileView}
          referrerPage={referrerPage}
        />
      )}
      {filteredPlatformData?.map((content, index) => {
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Hero_Banner || content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Hero_Promo_Banner) {
          return (
            <BannerSliderWithImage
              key={index}
              appVariant="at-home-page-banner"
              data={content?.banners}
              pageName={type}
              sectionName={DYNAMIC_DASHBOARD_COMPONENT_TYPES.Hero_Banner}
              homePage={screenType}
              analyticsProps={analyticsProps}
              bgColor={content?.bgColor}
              referrerPage={referrerPage}
              pageType={page_type || 'homepage'}
              isHeroPromoBanner={content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Hero_Promo_Banner}
            />
          );
        }

        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Business_Unit_Block) {
          return (
            <ModuleButtonStyled>
              {web_feature_flaging?.isOurServicesEnabled && <div className="redirectionHotLinks" key={index}>
                <Container>
                  {moreMenu.find((item) => item.key === KSA_FLAGSMITH_KEYS?.MORE_MENU?.AT_MODULE_SWITCHER)?.active && <Link href={generateURL(`${TELECONSULT_ROUTE}`)} passHref>
                    <a>
                      <ButtonBase
                        data-test="btnDoctor"
                        size="md"
                        variant="primary"
                        outerCustomClass="btnDoctor"
                        text={t('Home.consultDoctor')}
                        icon={IC_BTN_CONSULT_DOCTOR}
                        iconWidth="48px"
                        iconHeight="48px"
                        minWidth="360px"
                        onClick={() =>
                          dashboardNavigationHandler(
                            BUTTON_NAME?.AT,
                            TELECONSULT_ROUTE,
                            'global_button_click',
                            SCREEN_NAME?.ASCO,
                            MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
                          )
                        }
                        textClass="title"
                      />
                    </a>
                  </Link>}
                  {<Link href={generateURL(`${ONLINE_PHARMACY_ROUTE}`)} passHref>
                    <a>
                      <ButtonBase
                        data-test="btnEPharmacy"
                        size="md"
                        variant="primary"
                        outerCustomClass="btnEPharmacy"
                        text={t('Home.onlinePharmacy')}
                        icon={IC_BTN_EPHARMACY}
                        iconWidth="48px"
                        iconHeight="48px"
                        minWidth="360px"
                        onClick={() =>
                          dashboardNavigationHandler(
                            BUTTON_NAME?.AE,
                            ONLINE_PHARMACY_ROUTE,
                            'global_button_click',
                            SCREEN_NAME?.ASCO,
                            MY_ASTER_CATEGORY?.AE,
                          )
                        }
                        textClass="title"
                      />
                    </a>
                  </Link>}
                  {isHomecareEnabled && (
                    <Link href={generateURL(`${HOME_CARE_ROUTE}`)} passHref>
                      <a>
                        <ButtonBase
                          data-test="btnHomecare"
                          size="md"
                          variant="primary"
                          outerCustomClass="btnHomecare"
                          text={t('Home.homecare')}
                          icon={IC_BTN_HOMECARE}
                          iconWidth="48px"
                          iconHeight="48px"
                          minWidth="360px"
                          onClick={() =>
                            dashboardNavigationHandler(
                              BUTTON_NAME?.HC,
                              HOME_CARE_ROUTE,
                              'global_button_click',
                              SCREEN_NAME?.ASCO,
                              MY_ASTER_CATEGORY?.HC,
                            )
                          }
                          textClass="title"
                        />
                      </a>
                    </Link>
                  )}
                </Container>
              </div>}
            </ModuleButtonStyled>
          );
        }

        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Referral && web_feature_flaging?.isReferralBannerEnabled) {
          return (
            <Container className="pb-3" key="referral-banner">
              <ReferralInfoBanner
                analyticsProps={{
                  screenName: screenName || SCREEN_NAME?.ASCO,
                  pageType: props?.dynamicValue?.page_type || PAGE_NAME.ASCO,
                  referrerPage: props?.dynamicValue?.referrerPage || referrerPage,
                }}
                position="middle"
              />
            </Container>
          );
        }

        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Welcome_Offer && welcomeOfferData?.length && !hasPrevOrders?.length) {
          const titleStyle = {
            width: '298px',
            height: '23px',
            fontFamily: 'Mulish',
            fontSize: '18px',
            fontWeight: '700',
            lineHeight: '23px',
            letterSpacing: '0em',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            marginTop: '8px',
          };
          return (
            <div className="container">
              <div style={titleStyle} className="Welcome-title">
                {renderWelcomeOffer?.componentTitle}
              </div>
              <div style={{ padding: '15px 0' }}>
                <WelcomeOffer key={index} cmsResult={welcomeOfferData?.[0]} />
              </div>
            </div>
          );
        }

        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Promotional_Offer && promotionsOfferData?.length && promotionsOfferData) {
          const titleStyle = {
            fontFamily: 'Mulish',
            fontSize: '18px',
            fontWeight: '700',
            lineHeight: '23px',
            letterSpacing: '0em',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            marginTop: '10px',
          };

          return (
            <div className="container">
              <div style={titleStyle} className="Welcome-title">
                {renderPromotionalOffer?.componentTitle}
              </div>
              <div style={{ padding: '15px 0', height: 'auto' }}>
                <SlickSlider
                  sliderSettings={{
                    responsive,
                    slidesToShow: 3,
                    infinite: false,
                    className: '',
                    dots: false,
                    variableWidth: 3,
                  }}
                >
                  {promotionsOfferData.map((item) => (
                    <div
                      key={item?.id}
                      onClick={() => router.push({ pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${(item?.ctaLinkWebPath || item?.deepLinkUrlWeb)}`) })}
                    >
                      <PromotionalOffer key={item?.id} cmsResult={item} />
                    </div>
                  ))}
                </SlickSlider>
              </div>
            </div>
          );
        }

        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Instant_Booking_Banner) {
          return (
            <BannerConsultation
              key={index}
              data={content?.banners}
              screen={screenType}
              pageName={type}
              category={category}
              instantGP
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Two_in_One_Banner) {
          return (
            <OffBox
              key={index}
              data={content?.banners}
              pageName={type}
              sectionName='Two in One Banner'
              outerClass="mobile-rl-spacing"
              analyticsProps={analyticsProps}
              bgColor={content?.bgColor}
              referrerPage={referrerPage}
              pageType={page_type || 'homepage'}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Info_Cards) {
          return (
              <InfoCard key={index} data={content?.infoCardImages} title={content?.title} subTitle={content?.subTitle}/>
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.four_in_one_Banner) {
          return (
            <FourInOne
              key={index}
              data={content?.banners}
              pageName={type}
              sectionName='four-in-one Banner'
              analyticsProps={analyticsProps}
              referrerPage={referrerPage}
              pageType={page_type || 'homepage'}
              outerClass="mobile-rl-spacing"
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.five_in_one_Banner) {
          return (
            <FiveInOne
              key={index}
              data={content?.banners}
              pageName={type}
              sectionName='five-in-one Banner'
              outerClass="mobile-rl-spacing"
              analyticsProps={analyticsProps}
              referrerPage={referrerPage}
              pageType={page_type || 'homepage'}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.six_in_one_Banner) {
          return (
            <SixInOne
              key={index}
              title={content.title || ""}
              data={content?.banners}
              sectionName={content.source_type}
              pageName={type}
              viewAll={content?.viewAll}
              analyticsProps={analyticsProps}
              bgColor={content?.bgColor}
              pageType={page_type || 'homepage'}
              referrerPage={referrerPage}
              linkWebViewAll={content?.linkWebViewAll}
              singleLine={content?.singleLine}
              showTitles={content?.categoryTitlesShow}
              imageShape={content?.imageShape}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.eight_in_one_Banner) {
          return (
            <EightInOne
              key={index}
              title={content.title || ""}
              data={content?.banners}
              sectionName={content?.source_type}
              pageName={type}
              linkWebViewAll={content?.linkWebViewAll}
              viewAll={content?.viewAll}
              analyticsProps={analyticsProps}
              bgColor={content?.bgColor}
              referrerPage={referrerPage}
              pageType={page_type}
              singleLine={content?.singleLine}
              showTitles={content?.categoryTitlesShow}
              imageShape={content?.imageShape}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.category_carousel) {
          return (
            <CommonCategoryCarousel
              key={index}
              title={content.title || ""}
              data={content?.banners}
              sectionName={content?.source_type}
              pageName={type}
              linkWebViewAll={content?.linkWebViewAll}
              viewAll={content?.viewAll}
              analyticsProps={analyticsProps}
              bgColor={content?.bgColor}
              referrerPage={referrerPage}
              pageType={page_type}
              singleLine={content?.singleLine}
              showTitles={content?.categoryTitlesShow}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.My_Doctors) {
          return (
            <MyDoctor
              key={index}
              outerClass="mobile-my-doctor"
              title={content?.title}
              triggerMyDoctorList={triggerMyDoctorList}
              referrerPage={referrerPage}
              isGuest={isGuest}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Blog) {
          return (
            <CommonBlogCarousel
              blogCarouselData={content}
              page_type={props?.dynamicValue?.analyticsProps ? props?.dynamicValue?.analyticsProps?.page_type :
                props?.dynamicValue?.page_type}
              screen_name={props?.dynamicValue?.analyticsProps ? props?.dynamicValue?.analyticsProps?.screen_name :
                props?.dynamicValue?.screenName}
              myaster_category={props?.dynamicValue?.analyticsProps ? props?.dynamicValue?.analyticsProps?.myaster_category :
                props?.dynamicValue?.myaster_category}
            />
          );
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.New_Doctors) {
          return <NewDoctor
            key={index}
            outerClass="mobile-my-doctor mt-5"
            title={content.title || ""}
            referrerPage={referrerPage}
          />;
        }
        if (content?.source_id?.includes('Insider')) {
          return <InsiderRecCarousel
            insiderRecommendation={{ active: true, id: Number(content?.source_id?.split('_')[1]), title: content?.source_id?.includes('Insider') && content.title, type: "default" }}
            variationId={Number(content?.source_id?.split('_')[1])}
            asterRecommendation={null}
            productId={productIds}
            catId={''}
            insiderData={insiderReducer?.insider && insiderReducer?.insider[content?.source_id?.split('_')[1]]}
            linkWebViewAll={content?.source_id?.includes('Insider') && content?.linkWebViewAll}
            analyticsProps={{
              screenName: screenName || SCREEN_NAME?.ASCO,
              pageType: props?.dynamicValue?.page_type || PAGE_NAME.ASCO,
              referrerPage,
            }}
          />
        }
        if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Product_Carousel) {
          if (content?.carouselTypes === DYNAMIC_DASHBOARD_CAROUSEL_TYPES.Homecare_Services && enabledModules?.includes(MODULE?.HC)) {
            return (
              <CommonServiceCarousel
                key={index}
                brandId={content?.source_id}
                title={content?.title}
                carouselTypes={content?.carouselTypes}
                pageName={type}
                referrerPage={referrerPage}
                sourceType={content?.source_type}
                bgColor={content?.bgColor}
              />
            );
          }
          if (content?.carouselTypes === DYNAMIC_DASHBOARD_CAROUSEL_TYPES.Homecare_Packages && enabledModules?.includes(MODULE?.HC)) {
            return (
              <CommonPackageCarousel
                key={index}
                brandId={content?.source_id}
                title={content?.title}
                carouselTypes={content?.carouselTypes}
                pageName={type}
                referrerPage={referrerPage}
                sourceType={content?.source_type}
              />
            );
          }
          if (content?.carouselTypes === DYNAMIC_DASHBOARD_CAROUSEL_TYPES.Clinic_Packages && enabledModules?.includes(MODULE?.AT)) {
            return (
              <PackageCarousel
                key={index}
                packageId={content?.source_id}
                title={content?.title}
                carouselTypes={content?.carouselTypes}
                pageName={type}
                referrerPage={referrerPage}
                isReload={isReload}
              />
            );
          }
          return (
            <CommonProductCarousel
              key={index}
              brandId={content?.source_id}
              title={content?.title || ""}
              carouselTypes={content?.carouselTypes}
              pageName={type}
              referrerPage={referrerPage}
              sourceType={content?.source_type}
              linkWebViewAll={content?.linkWebViewAll}
              viewAll={content?.viewAll}
              type={type}
              pageType={props?.dynamicValue?.page_type || PAGE_NAME.ASCO}
              screenType={screenName || screenType}
              bgColor={content?.bgColor}
            />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Saved_Products) {
          return <RecentlySaved key={index} title={content?.title || ""} isReload={isReload} pageName={type} />;
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Promotional_Banner) {
          return (
            <StaticBannerWithImage
              key={index}
              data={content?.banners}
              pageName={type}
              sectionName='Promotional Banner'
              analyticsProps={analyticsProps}
              referrerPage={referrerPage}
              pageType={page_type || 'homepage'}
            />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Brand_Carousel) {
          return (
            <ShopByBrands
              key={index}
              isReload={isReload}
              title={content?.title}
              linkWebViewAll={content?.linkWebViewAll}
              sectionName={content?.source_type}
              viewAll={content?.viewAll}
              pageName={type}
              bgColor={content?.bgColor}
              referrerPage={referrerPage}
              pageType={page_type}
            />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Upload_Prescription) {
          return (
            <QuickUploadPrescription
              key={index}
              title={content?.title}
              homeCare={content?.businessUnit === 'Homecare'}
            />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Quick_Banner) {
          return (
            <BannerConsultation
              key={index}
              guest={guestLogin}
              data={content?.banners}
              screen={screenType}
              pageName={type}
              category={category}
              analyticsProps={analyticsProps}
            />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Facilities_near_you) {
          return (
            <ClinicNearby key={index} outerClass="mobile-clinic-nearby" screen={screenType} title={content.title || ""} />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.HTML_Block || content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Custom_Block) {
          return (
            <HtmlBlock key={index} outerClass="mobile-clinic-nearby" type={content?.component_type} data={content} />
          );
        } else if (content?.component_type === DYNAMIC_DASHBOARD_COMPONENT_TYPES.Quick_Links) {
          return (
            <QuickLinks key={index} data={content} screen={screenType} referrerPage={referrerPage} pageName={type} />
          );
        }
        return null;
      })}
    </DynamicDashboardStyled>
  );
};

DynamicDashboard.defaultProps = {
  props: 'json',
};

DynamicDashboard.propTypes = {
  content: PropTypes.any,
  referrerPage: PropTypes.string,
  cmsResult: PropTypes.object,
  type: PropTypes.string,
  screenType: PropTypes.string,
  dynamicValue: PropTypes.any,
  setIsMemberAdded: PropTypes.func,
  analyticsProps: PropTypes.object
};

export default DynamicDashboard;
